export default from './avatar-image';



// WEBPACK FOOTER //
// ./app/components/avatar-image/index.js